import messages from "./messages";

export const resetPasswordPageConfig = [
  {
    id: "newPassword",
    label: messages.newPassword,
  },
  {
    id: "confirmPassword",
    label: messages.confirmPassword,
  },
];
